import { siteConfig } from "@/config/site.config";

/**
 * Filter a mock product list by ProductFilters. Kept pure so it can serve as
 * the reference implementation once a real backend is connected.
 */
export function applyProductFilters(products, filters = {}) {
    const {
        search = "",
        category = [],
        type = [],
        size = [],
        condition = [],
        availability = [],
        featured,
        page = 1,
        pageSize = 12,
        sort = "featured",
    } = filters;

    let items = products.filter((p) => p.status === "published");

    if (search) {
        const q = search.toLowerCase();
        items = items.filter(
            (p) =>
                p.name.toLowerCase().includes(q) ||
                p.shortDescription.toLowerCase().includes(q) ||
                p.containerType.toLowerCase().includes(q) ||
                p.size.toLowerCase().includes(q) ||
                p.applications.some((a) => a.toLowerCase().includes(q)),
        );
    }
    if (category.length) items = items.filter((p) => category.includes(p.categoryId));
    if (type.length) items = items.filter((p) => type.includes(p.containerType));
    if (size.length) items = items.filter((p) => size.includes(p.size));
    if (condition.length) items = items.filter((p) => condition.includes(p.condition));
    if (availability.length) items = items.filter((p) => availability.includes(p.availability));
    if (typeof featured === "boolean") items = items.filter((p) => p.featured === featured);

    items.sort((a, b) => {
        switch (sort) {
            case "newest":
                return new Date(b.createdAt) - new Date(a.createdAt);
            case "size":
                return a.size.localeCompare(b.size);
            case "category":
                return a.categoryName.localeCompare(b.categoryName);
            case "featured":
            default:
                return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
        }
    });

    const totalItems = items.length;
    const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
    const start = (page - 1) * pageSize;
    const pagedItems = items.slice(start, start + pageSize);

    return {
        items: pagedItems,
        page,
        pageSize,
        totalItems,
        totalPages,
    };
}

export const CONTAINER_TYPES = [
    "Storage Container",
    "Cargo-Worthy Container",
    "Office Container",
    "Workers' Quarters",
    "Sanitary or Toilet Container",
    "Guard House",
    "Refrigerated Container",
    "Customised Container",
    "Other",
];

export const CONTAINER_SIZES = ["20ft × 8ft", "40ft × 8ft", "20ft × 10ft", "40ft × 10ft", "Other"];

export const CONTAINER_CONDITIONS = [
    { value: "new", label: "New" },
    { value: "used", label: "Used" },
    { value: "refurbished", label: "Refurbished" },
    { value: "custom-build", label: "Custom Build" },
];

export const AVAILABILITY_OPTIONS = [
    { value: "available", label: "Available" },
    { value: "limited", label: "Limited Availability" },
    { value: "made-to-order", label: "Made to Order" },
    { value: "enquire", label: "Enquire for Availability" },
];

export const SORT_OPTIONS = [
    { value: "featured", label: "Featured" },
    { value: "newest", label: "Newest Listings" },
    { value: "size", label: "Container Size" },
    { value: "category", label: "Category" },
];

export function absoluteUrl(path = "/") {
    const base = siteConfig.siteUrl.replace(/\/$/, "");
    return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}
